document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('[data-beautystore-info-popup]');

  if (!popup) return;

  var box = popup.querySelector('.beautystore-info-popup__box');
  var closeButtons = popup.querySelectorAll('[data-popup-close]');
  var frequency = popup.dataset.frequency || 'forever';
  var storageKey = popup.dataset.storageKey || 'beautystore-info-popup';
  var delay = Number(popup.dataset.delay || 2000);
  var lastFocusedElement = null;
  var previousBodyOverflow = '';

  function readLocalValue() {
    try {
      return localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  }

  function shouldShow() {
    if (window.Shopify && Shopify.designMode) {
      return true;
    }

    if (frequency === 'always') {
      return true;
    }

    if (frequency === 'session') {
      try {
        return !sessionStorage.getItem(storageKey);
      } catch (error) {
        return true;
      }
    }

    var lastShown = readLocalValue();

    if (!lastShown) {
      return true;
    }

    var elapsed = Date.now() - Number(lastShown);

    if (frequency === 'day') {
      return elapsed >= 24 * 60 * 60 * 1000;
    }

    if (frequency === 'week') {
      return elapsed >= 7 * 24 * 60 * 60 * 1000;
    }

    return false;
  }

  function markAsShown() {
    if (frequency === 'always') {
      return;
    }

    if (frequency === 'session') {
      try {
        sessionStorage.setItem(storageKey, 'true');
      } catch (error) {
        // The popup remains usable when session storage is unavailable.
      }
      return;
    }

    try {
      localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {
      // The popup remains usable when local storage is unavailable.
    }
  }

  function openPopup() {
    lastFocusedElement = document.activeElement;
    previousBodyOverflow = document.body.style.overflow;
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    markAsShown();

    if (box) {
      box.focus();
    }
  }

  function closePopup() {
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = previousBodyOverflow;

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      closePopup();
    }
  });

  if (shouldShow()) {
    window.setTimeout(openPopup, delay);
  }
});